import React, { useState, useEffect, useContext } from 'react';

import { PracticeReseveContext } from '../../PracticeReseveContext';

import {
  PracticeReserveSituationDisplaySituation,
  PracticeReserveSituationValue
} from '../../../../../models/practice/reserve/situation/PracticeReserveSituation';


// フリートーク：トピック
function PracticeReserveFreeTalkTopick() {

  const {
    displaySituations, selectedSituation,
    instProfile
  } = useContext(PracticeReseveContext);

  const [isDisp, setIsDisp] = useState<boolean>(false);


  useEffect(() => {
    let isNewDisp = false;

    // フリートーク/ディスカッションが選択済みか確認
    if(displaySituations) {
      // フリートーク/ディスカッション内のカテゴリID
      const freeTalkCategoryIdList = displaySituations.find(
        (item: PracticeReserveSituationDisplaySituation) => item.key === 20
      )?.value.map((v: PracticeReserveSituationValue) => v.id) || [];
      // 選択判定
      isNewDisp = freeTalkCategoryIdList.includes(selectedSituation);
    }

    // 選択講師にフリートピックが設定されているか
    if(isNewDisp) {
      isNewDisp = Array.isArray(instProfile?.free_topics) && instProfile.free_topics.length > 0;
    }

    setIsDisp(isNewDisp);
  }, [displaySituations, instProfile, selectedSituation])


  
  return (
    <>
    {isDisp &&
      <div
        className="alert alert-info"
        style={{ marginBottom: '20px' }}
      >
        <small>

          <strong>
            ※フリートーク選択時は{instProfile.name}専用トピックでセッション可能です。
          </strong>

          <hr style={{ margin: '10px 0', padding: 0 }} />

          {instProfile.free_topics.map((list: string, index: number) => (
            <React.Fragment key={index}>
              ・{list}
              <br />
            </React.Fragment>
          ))}

        </small>
      </div>
    }
    </>
  );
}
  
export default PracticeReserveFreeTalkTopick;